// components/Hero.jsx
import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from "react-router-dom"; // Ajoute cet import
import train from "../assets/train.png";
import pmi from "../assets/pmi-premier.png";
import carrousel from "../assets/ban.jpg";
import heroVideo from "../assets/website_video.mp4";
import { FaSearch } from "react-icons/fa";
import "./Hero.css";
import EligibilityModal from './EligibilityModal';

const HeroSection = ({ scrollToCalendar, openEligibilityModal }) => {
  const navigate = useNavigate(); // Ajoute ce hook
  const [showEligibilityModal, setShowEligibilityModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [placeholderText, setPlaceholderText] = useState("");
  const [isTyping, setIsTyping] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);
  const [loopNum, setLoopNum] = useState(0);
  const videoRef = useRef(null);

  // Texte à animer
  const texts = [
    'Project Management Professional (PMP)®',
    'Primavera P6 : Planification et suivi de projets',
    'Communications dans les environnements bâtis',
    'Gestion du périmètre et des modifications dans les environnements bâtis',
    'Gestion des interfaces dans les environnements bâtis',
    'Gestion des contrats et des risques dans les environnements bâtis',
    'Certified Associate in Project Management (CAPM)®',
    'Professional Scrum Master™ I (PSM I)',
    'PMI Risk Management Professional (PMI-RMP)®',
    'PMI® PMO Certified Professional (PMI-PMOCP)™',
    'PMI Agile Certified Practitioner (PMI-ACP)®',
    'Microsoft Power BI : Visualisation de données projets',
    'Microsoft Project : Planification et suivi de projets',
    'Jira : Planification et suivi de projets'
  ];
  const typingSpeed = 100;
  const deletingSpeed = 50;
  const pauseTime = 1500;

  useEffect(() => {
    let timer;
    const currentText = texts[loopNum % texts.length];

    if (isTyping) {
      timer = setTimeout(() => {
        setPlaceholderText(currentText.substring(0, placeholderText.length + 1));
        if (placeholderText === currentText) {
          setIsTyping(false);
          setTimeout(() => setIsDeleting(true), pauseTime);
        }
      }, typingSpeed);
    } else if (isDeleting) {
      timer = setTimeout(() => {
        setPlaceholderText(currentText.substring(0, placeholderText.length - 1));
        if (placeholderText === '') {
          setIsDeleting(false);
          setIsTyping(true);
          setLoopNum(loopNum + 1);
        }
      }, deletingSpeed);
    }

    return () => clearTimeout(timer);
  }, [placeholderText, isTyping, isDeleting, loopNum]);

  const handleEligibilityComplete = (results) => {
    console.log('Résultats du questionnaire:', results);
    setShowEligibilityModal(false);

    if (results.recommendation.certification === 'PMP') {
      scrollToCalendar();
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      console.log("Recherche :", searchQuery);
      alert(`Recherche pour : ${searchQuery}`);
    }
  };

  // Dans ton state ou props
  const [heroData, setHeroData] = useState({
    title: "Améliorez la performance de vos projets et certifiez vos chefs de projet.",
    description: "Nous accompagnons les entreprises et les professionnels à réussir leurs projets grâce à des méthodes éprouvées et des certifications reconnues (PMP<sup>®</sup>, CAPM<sup>®</sup>, PMI-CP<sup>™</sup>, PSM 1<sup>™</sup>, ITIL 5<sup>®</sup> …)."
  });

  const [videoError, setVideoError] = useState(false);

  return (
    <>
      <div className="hero-section">
        <div className="hero-banner">
          {/* <div className="hero-video">
            <img src={carrousel} alt="Bannière de formation" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          </div> */}

          {!videoError ? (
            <video
              className="hero-video"
              autoPlay
              loop
              muted
              playsInline
              onError={() => setVideoError(true)}
            >
              <source src={heroVideo} type="video/mp4" />
              {/* <source src={heroVideoWebm} type="video/webm" /> */}
            </video>
          ) : (
            <img
              src={carrousel}
              alt="Bannière de formation"
              className="hero-video"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          )}

          <div className="hero-overlay"></div>

          <div className="hero-content hero-content-container">
            {/* Logo PMI centré et agrandi */}
            <div className="hero-logo-container">
              <a
                href="https://www.credly.com/badges/ada65326-d394-4cf7-91a7-35956cb7a384/public_url"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={pmi} alt="Logo PMI" className="" style={{ height: "200px", paddingBottom: "15px" }} />
              </a>
            </div> 

            <h2 className="hero-title hero-title-animation">
              <span className="title-white">
                {heroData.title}
              </span>
            </h2>
            {heroData.description && (
              <p
                className="hero-description hero-description-animation"
                dangerouslySetInnerHTML={{ __html: heroData.description }}
              />
            )}

            {/* <form
              className="hero-search-form hero-search-animation"
              onSubmit={handleSearch}
            >
              <div className="search-input-container">
                <FaSearch className="search-icon" />
                <input
                  type="text"
                  placeholder={placeholderText}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="search-input"
                  aria-label="Rechercher une formation ou un programme"
                />
                <div className="typing-cursor"></div>
                <button
                  type="submit"
                  className="search-submit-btn"
                  aria-label="Lancer la recherche"
                >
                  Rechercher
                </button>
              </div>
            </form> */}

            <div className="hero-buttons hero-buttons-animation">
              <button
                className="hero-btn hero-btn-secondary"
                onClick={() => navigate('/entreprises')}
              >
                Je veux réussir mes projets
              </button>
              <button
                className="hero-btn hero-btn-primary"
                onClick={() => navigate('/formations')}
              >
                Je veux renforcer mes capacités
              </button>
            </div>
          </div>
        </div>
      </div>

      <EligibilityModal
        isOpen={showEligibilityModal}
        onClose={() => setShowEligibilityModal(false)}
        onComplete={handleEligibilityComplete}
      />
    </>
  );
};

export default HeroSection;